export default __webpack_public_path__ + "static/media/Snd_LowerDDownBump.278d81a2.mp3";